'use client';

import type { ReactNode } from 'react';
import { ChevronIcon } from '@/assets/icons/ChevronIcon';
import styles from './modalNavWrapper.module.scss';

const { modalNavWrapper, modalNavigation, chevronIconWrapper } = styles;

type ModalNavWrapperProps = {
    children: ReactNode;
    footer?: ReactNode;
    showBackButton?: boolean;
    onBackClick?: () => void;
    backButtonAriaLabel?: string;
};

export function ModalNavWrapper({
    children,
    footer,
    showBackButton = false,
    onBackClick,
    backButtonAriaLabel = 'Back',
}: ModalNavWrapperProps) {
    return (
        <div className={modalNavWrapper}>
            {showBackButton && (
                <div className={modalNavigation}>
                    <button
                        type="button"
                        className={chevronIconWrapper}
                        aria-label={backButtonAriaLabel}
                        onClick={onBackClick}
                    >
                        <ChevronIcon direction="left" />
                    </button>
                </div>
            )}
            {children}
            {footer}
        </div>
    );
}
